{
  "version": 1,
  "asset_id": "d323d55e-cda0-4ffb-8b19-013fa81d4d7e",
  "project_id": "1203040e-940d-4f2e-ab5b-8733ed2d3c31",
  "url": "/__l5e/assets-v1/d323d55e-cda0-4ffb-8b19-013fa81d4d7e/opt_assistido-2.jpg",
  "r2_key": "a/v1/1203040e-940d-4f2e-ab5b-8733ed2d3c31/d323d55e-cda0-4ffb-8b19-013fa81d4d7e/opt_assistido-2.jpg",
  "original_filename": "opt_assistido-2.jpg",
  "size": 86716,
  "content_type": "image/jpeg",
  "created_at": "2026-08-26T20:32:53Z"
}
